/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../usermessagetype.ts" />
/// <reference path="errorhandlerservice.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="../iapirequestconfig.ts" />
/// <reference path="usermessagesservice.ts" />
/// <reference path="../iresultwithmessages.d.ts" />

module App.Common.Services {
	'use strict';

	export class ApiService {

		public static $inject = [
			'$http',
			'$q',
			'$localStorage',
            '$injector',
			'app.common.services.userMessagesService',
			'app.common.services.errorHandlerService',
            'app.common.services.globalSettingsService',
			'Analytics'
		];

		constructor(
			private $http: angular.IHttpService,
			private $q: angular.IQService,
            private $localStorage: Common.ILocalStorage,
            private $injector: angular.auto.IInjectorService,
			private userMessages: Services.UserMessagesService,
			private errorHandler: Services.ErrorHandlerService,
            private globalSettings: Services.GlobalSettingsService,
			private analytics: any) {
		}
		public messageBoxWindow: angular.ui.bootstrap.IModalServiceInstance;

		public get(config: Common.IApiRequestConfig): angular.IPromise<any> { return this.action('GET', config); }

		public head(config: Common.IApiRequestConfig): angular.IPromise<any> { return this.action('HEAD', config); }

		public post(config: Common.IApiRequestConfig): angular.IPromise<any> { return this.action('POST', config); }

		public put(config: Common.IApiRequestConfig): angular.IPromise<any> { return this.action('PUT', config); }

		public delete(config: Common.IApiRequestConfig): angular.IPromise<any> { return this.action('DELETE', config); }

		public patch(config: Common.IApiRequestConfig): angular.IPromise<any> { return this.action('PATCH', config); }

		private action(method: string, config: Common.IApiRequestConfig): angular.IPromise<any> {

			if (!method || !config || method === 'POST' && !config.data) {
				throw ('Invalid args');
			}

			config.url = config.resourceName ? `api/${config.resourceName}` : config.url;
			config.method = method;

			if (config.method !== 'GET' && config.method !== 'HEAD') {
				this.userMessages.clear();
			}

			if (!config.headers) {
				config.headers = {} as angular.IHttpRequestConfigHeaders;
			}

			this.addDefaultHeaders(config);

			//If left unspecified, the call is assumed to require authentication. Only config.authenticated === false prevents this
			if (typeof (config.authenticated) === 'undefined' || config.authenticated === null || config.authenticated) {
				this.addAuthHeaderWithToken(config);
			}

			//this.analytics.trackPage(config.url);

			return this.$http(config as angular.IRequestConfig)
				.then((result: angular.IHttpPromiseCallbackArg<Common.IResultWithMessagesAndValue<any>>) => {
					return this.unwrapResult(result);
				},
				(result: angular.IHttpPromiseCallbackArg<any>) => {

					var requestConfig = result.config as IApiRequestConfig;

					if (result.status === 401 && requestConfig.authenticated) {
						return this.$injector
							.get<Services.AuthenticationService>('app.common.services.authenticationService')
							.reauthenticate()
							.then(() => {
								this.$http(config as angular.IRequestConfig)
									.then((retryResult: angular.IHttpPromiseCallbackArg<Common.IResultWithMessagesAndValue<any>>) => {
										return this.unwrapResult(retryResult);
									}, (retryResult: angular.IHttpPromiseCallbackArg<Common.IResultWithMessagesAndValue<any>>) => {
										return this.errorHandler.handleHttpError(retryResult, config.suppressHttpErrorDisplay);
									});
							});
					} else {
						return this.errorHandler.handleHttpError(result, config.suppressHttpErrorDisplay);
					}
				});

		}

		public addDefaultHeaders(config: Common.IApiRequestConfig | angular.IRequestConfig): void {

			if (!config) { return; }
			if (!config.headers) { config.headers = {}; }

			if (!config.headers['Accept']) {
				config.headers['Accept'] = 'application/json';
			}
			if (!config.headers['Content-Type']) {
				config.headers['Content-Type'] = 'application/json';
			}
		}

		public addAuthHeaderWithToken(config: Common.IApiRequestConfig | angular.IRequestConfig): void {

			if (!config) { return; }
			if (!config.headers) { config.headers = {}; }

			config.headers['Authorization'] = `Bearer ${this.$localStorage.authToken ? this.$localStorage.authToken.access_token : ''}`;
		};

		private unwrapResult(result: angular.IHttpPromiseCallbackArg<any>): any {

			if (!result) { return null; }

			var config = result.config as Common.IApiRequestConfig;

			var hasErrorMessages = false;

			if (result.data && result.data.userMessages != null) {

				hasErrorMessages = result.data.userMessages.errorMessages && result.data.userMessages.errorMessages.length;

				if (config.method !== 'GET' && config.method !== 'HEAD' && !config.suppressSuccessMessage && !hasErrorMessages) {
					this.userMessages.addMessage(config.successMessage || 'Action completed successfully',
						UserMessageType.Success,
						config.deferUserMessageDisplay);
				}
				if (result.data && result.data.userMessages) {
					this.userMessages.addMessages(result.data.userMessages, !hasErrorMessages && config.deferUserMessageDisplay);
				}
			}

			var unwrapped = result.data && result.data.value ? result.data.value : result.data;
			return hasErrorMessages
				? this.$q.reject(unwrapped)
				: this.$q.resolve(unwrapped);
		}

	}

	angular
		.module('app.common.services')
		.service('app.common.services.apiService', ApiService);

}